<template>
  <label class="toggle">
    <input
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="track" />
  </label>
</template>

<script>
// Toggle switch (.toggle — nunca .switch, que colide com a barra proto).
// v-model compatível (prop value / evento input).
export default {
  name: "ClinicToggle",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
};
</script>
